// Discount specific widgets
import { XVIToolbarComponent } from './toolbar/toolbar.component';
import { XVISchemaFormGroupComponent } from './schema-form-group/schema-form-group.component';
import { XVIErrorBlockComponent } from './error-block/error-block.component';
import { XVILabelComponent } from './label/label.component';
import { XVIInputNumberComponent } from './input-number/input-number.component';
import { XVIInputCurrencyComponent } from './input-currency/input-currency.component';
import { XVIInputComponent } from './input/input.component';
import { CommonFormComponent } from './common-form/common-form.component';
import { XVILabelBlockComponent } from './label-block/label-block.component';

export { ValidationService } from './services/validation/validation.service';

export const formComponents: any[] = [
  XVIToolbarComponent,
  XVISchemaFormGroupComponent,
  XVIErrorBlockComponent,
  XVILabelComponent,
  XVIInputNumberComponent,
  XVIInputCurrencyComponent,
  XVIInputComponent,
  CommonFormComponent,
  XVILabelBlockComponent,
];
